import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import HeaderSection from "../HeaderSection";

const CandidateSourcing = () => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [candidates, setCandidates] = useState([]);
    const [isUploaded, setIsUploaded] = useState(false);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!file) {
            toast.error("Please select a JD file to upload"); //
            return;
        }

        const formData = new FormData();
        formData.append("Job_Description", file);

        setLoading(true);
        try {
            const response = await axios.post(
                "https://neovlm.neophyte.live/n8n-newsletter/webhook/7e27c865-fe4c-4198-9d44-a3b26466f3fb",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log("Webhook response:", response.data);

            // Parsing the search_result from the response metadata provided by the user
            const fetchedCandidates = response.data?.search_result || [];

            setCandidates(fetchedCandidates);
            setIsUploaded(true);
            toast.success("JD uploaded successfully! Profiles fetched.");
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Failed to fetch candidates. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-content">
            <style>{`
                .linkedin-card {
                    transition: transform 0.2s, box-shadow 0.2s;
                    border: 1px solid #e1e9ee;
                    border-radius: 8px;
                    overflow: hidden;
                    background: #fff;
                }
                .linkedin-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
                    border-color: #0077b5;
                }
                .profile-link {
                    color: #0077b5;
                    font-weight: 600;
                    text-decoration: none;
                }
                .profile-link:hover {
                    text-decoration: underline;
                }
                .snippet-text {
                    font-size: 0.9rem;
                    color: #666;
                    line-height: 1.4;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .favicon-img {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                }
                .source-badge {
                    font-size: 0.75rem;
                    background: #f3f6f8;
                    padding: 2px 8px;
                    border-radius: 4px;
                    color: #666;
                }
            `}</style>

            <section className="section">
                <HeaderSection title="Candidate Sourcing" />

                <div className="section-body">
                    <div className="card">
                        <div className="card-header">
                            <h4>Upload Job Description</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleUpload}>
                                <div className="form-group">
                                    <label>Choose JD File (PDF or Word)</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={handleFileChange}
                                        accept=".pdf,.doc,.docx"
                                    />
                                    <small className="form-text text-muted">
                                        Upload the JD to find matching LinkedIn profiles.
                                    </small>
                                </div>
                                <button
                                    type="submit"
                                    className={`btn btn-primary ${loading ? 'btn-progress' : ''}`}
                                    disabled={loading}
                                >
                                    {loading ? 'Processing...' : 'Find LinkedIn Profiles'}
                                </button>
                            </form>
                        </div>
                    </div>

                    {isUploaded && (
                        <div className="mt-4">
                            <div className="section-title">Fetched Profiles ({candidates.length})</div>
                            <div className="row">
                                {candidates.length > 0 ? (
                                    candidates.map((candidate, index) => (
                                        <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                                            <div className="card h-100 linkedin-card">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center mb-2">
                                                        {candidate.favicon && (
                                                            <img src={candidate.favicon} alt="favicon" className="favicon-img" />
                                                        )}
                                                        <span className="source-badge">{candidate.source || 'LinkedIn'}</span>
                                                    </div>
                                                    <h5 className="mb-2">
                                                        <a
                                                            href={candidate.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="profile-link"
                                                        >
                                                            {candidate.title.split(' - ')[0]}
                                                        </a>
                                                    </h5>
                                                    <div className="text-muted small mb-3">
                                                        {candidate.title.split(' - ')[1] || candidate.displayed_link}
                                                    </div>
                                                    <p className="snippet-text">
                                                        {candidate.snippet}
                                                    </p>
                                                </div>
                                                <div className="card-footer bg-whitesmoke d-flex justify-content-end align-items-center">
                                                    <a
                                                        href={candidate.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-primary btn-sm"
                                                    >
                                                        View Profile
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <div className="card">
                                            <div className="card-body">
                                                No LinkedIn profiles found for this JD.
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default CandidateSourcing;
